import 'regenerator-runtime/runtime'
import {
  SurveyInstanceExecutionServicePromiseClient,
  ExecCompleteQuestionRequest,
  setRequest,
} from '@utils/index'

type Params = ExecCompleteQuestionRequest.AsObject

const {
  REACT_APP_QUERY_HOST = 'https://staging.pandolink.com',
  REACT_APP_QUERY_PORT = '443',
} = process.env

export const execCompleteQuestion = async (
  params: Params,
  accessToken: string
) => {
  const service = new SurveyInstanceExecutionServicePromiseClient(
    `${REACT_APP_QUERY_HOST}:${REACT_APP_QUERY_PORT}`
  )

  const request = setRequest(new ExecCompleteQuestionRequest(), params)

  const result = await service.execCompleteQuestion(request, {
    authorization: `Bearer ${accessToken}`,
  })

  return result
}
